import { OSKIconDefinition } from '../osk-icon.types';

export const oskIconChevronRight: OSKIconDefinition = {
  name: 'chevron-right',
  content: '<path d="m9 18 6-6-6-6" />'
};
